import React from "react";
import { useState } from "react";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { Link } from "react-router-dom";

const PopOver = ({ users, item, removeMonitorHandler }) => {
  const [isPopoverVisible, setPopoverVisible] = useState(false);
  const renderPopOver = (uuid) => {
    return (
      <Popover id="popover-positioned-left">
        <Popover.Header>
          <div className="headerSec">
            <div className="profileimage">
              <img src={users[uuid]?.profile_image} />
            </div>
            <div className="bio-data">
              <div className="profileName">
                <div className="profileName">{users[uuid]?.name}</div>
              </div>
            </div>
          </div>
        </Popover.Header>
        <Popover.Body>
          <div className="popupbody">
            <div className="bodyemail">
              <span>
                <i className="fa fa-envelope"></i>
              </span>
              <span>{users[uuid]?.email}</span>
            </div>
            {users[uuid]?.is_group != 1 && (
              <div className="bodycompany">
                <span>
                  <i class="fa fa-address-card" aria-hidden="true"></i>
                </span>{" "}
                {users[uuid]?.position && (
                  <div className="position">{users[uuid]?.position}</div>
                )}
              </div>
            )}
          </div>
          <div className="popfooter">
            {users[uuid]?.is_group == 1 ? (
              <a
                href={users[uuid]?.profile_url ? users[uuid]?.profile_url : "#"}
                target="_blank"
              >
                View Group
              </a>
            ) : (
              <a
                href={users[uuid]?.profile_url ? users[uuid]?.profile_url : "#"}
                target="_blank"
              >
                View Profile
              </a>
            )}
          </div>
        </Popover.Body>
      </Popover>
    );
  };
  const handlePopoverToggle = () => {
    setPopoverVisible(!isPopoverVisible);
  };
  return (
    <>
      <div
        onMouseEnter={handlePopoverToggle}
        onMouseLeave={handlePopoverToggle}
      >
        {" "}
        <OverlayTrigger
          trigger="hover"
          show={isPopoverVisible}
          placement="auto"
          overlay={renderPopOver(item?.user_uuid)}
        >
          <div class="img-box" key={item?.user_uuid}>
            <img
              src={item?.profile_image}
              style={{ width: "28px", height: "28px" }}
            />
            <div
              class="img-cross"
              onClick={() => removeMonitorHandler(item?.user_uuid)}
              // title={`${item?.name.charAt(0).toUpperCase()}${item?.name?.slice(
              //   1
              // )}`}
            >
              <svg
                width="8"
                height="8"
                viewBox="0 0 8 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8 0.7L7.3 0L4 3.3L0.7 0L0 0.7L3.3 4L0 7.3L0.7 8L4 4.7L7.3 8L8 7.3L4.7 4L8 0.7Z"
                  fill="white"
                ></path>
              </svg>
            </div>
          </div>
        </OverlayTrigger>
      </div>
    </>
  );
};

export default PopOver;
